import { Component, ChangeDetectionStrategy, Input, OnInit } from '@angular/core';
import { LinkTarget } from '@modules/content-api/adapter/info-section.adapter';
import { QAForm } from '@modules/content-api/adapter/qaform.adapter';
import { ContactService } from '@modules/shared/services/contact.service';
import { InfoVariant } from '@modules/ui/info/info.component';

const INFO_TYPE_STYLE: {
  [k in InfoVariant]: {
    infoType: InfoVariant;
    iconClass: string;
    buttonClass: string;
  };
} = {
  primary: {
    infoType: 'primary',
    iconClass: 'mb-icon-info-circle',
    buttonClass: 'btn-tertiary',
  },
  secondary: {
    infoType: 'secondary',
    iconClass: 'mb-icon-info-circle',
    buttonClass: 'btn-secondary',
  },
  info: {
    infoType: 'info',
    iconClass: 'mb-icon-info-circle',
    buttonClass: 'btn-secondary',
  },
  success: {
    infoType: 'success',
    iconClass: 'mb-icon-marked-ok',
    buttonClass: 'btn-tertiary',
  },
  warning: {
    infoType: 'warning',
    iconClass: 'mb-icon-attention-circle',
    buttonClass: 'btn-tertiary',
  },
  danger: {
    infoType: 'danger',
    iconClass: 'mb-icon-attention-circle',
    buttonClass: 'btn-tertiary',
  },
};
@Component({
  selector: 'mb-info-section',
  templateUrl: './info-section.component.html',
  styleUrls: ['./info-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoSectionComponent implements OnInit {
  @Input() infoType: InfoVariant = 'primary';
  @Input() anchor!: string;
  @Input() headline?: string;
  @Input() text?: string;
  @Input() buttonLabel?: string;
  @Input() buttonLink?: string;
  @Input() buttonTargetType: LinkTarget = 'blank';
  @Input() qaForm?: QAForm;

  public config!: typeof INFO_TYPE_STYLE.primary;
  public linkType: 'internal' | 'external' | 'modal' = 'external';

  constructor(private contactService: ContactService) {}

  ngOnInit() {
    this.config = INFO_TYPE_STYLE[this.infoType] || {
      infoType: 'primary',
      iconClass: 'info-circle',
      buttonClass: 'btn-tertiary',
    };

    if (this.buttonTargetType === 'modal') {
      this.linkType = 'modal';
    } else {
      this.linkType = this.buttonLink?.startsWith('http') ? 'external' : 'internal';
      if (this.linkType === 'internal') {
        // remove internal: prefix which is being added by Drupal
        this.buttonLink = this.buttonLink?.replace(/^internal:/, '');
      }
    }
  }

  openQaForm() {
    this.contactService.openQaForm(this.qaForm);
  }
}
